<section>
    <h2>Achievements</h2>
    <div class="project">
        <li>
            Won 1000 dollars at the ETHIndia Hackathon under the 'Best use of
            dApp Launchpad' track by Polygon Labs
        </li>
        <li>
            India Rank 1, and Global Rank 36 out of 15000 in the Round 942 Div 2
            Contest on Codeforces
        </li>
        <li>
            India Rank 4, and Global Rank 121 out of 17400 in the Div 3 Contest
            on Codeforces
        </li>
        <li>
            1860 (Expert) Top 300 in India (0.01 %tile in India) at CodeForces
            and 2037 (5 stars) at CodeChef
        </li>
        <li>
            ACM ICPC 2021, 2022 and 2023 Indian regionals collectively for 5
            on-site regionals
        </li>
        <li>
            AIR 365 in Google Kickstart Round D 2022, AIR 415 in Google HashCode
        </li>
    </div>
</section>

<style>
    section {
        padding: 20px;
        /* margin: 0 300px; */
    }

    h2 {
        font-size: 2.5rem;
        display: flex;
        margin-top: 10px;
        color: tomato;
        margin-bottom: -10px;
        border-bottom: 5px solid var(--border-color);
    }

    .project {
        padding: 20px 0;
    }

    .project li {
        word-spacing: 0.1cm;
        letter-spacing: 0.01cm;
        margin: 10px 0px;
        color: var(--experience-description) white;
        font-size: 1.2rem;
    }
</style>
